export default {
  methods: {
    weekDaysSelection() {
      let startDay = this.$moment(this.form.start_date);
      let endDay = this.$moment(this.form.end_date);
      let weekdays = [];

      do {
        weekdays = [...weekdays, startDay.day()];
        startDay.add(1, 'day');
      } while (startDay.isSameOrBefore(endDay));

      this.form.weekdays = [...new Set(weekdays)];;
    }
  },
  watch: {
    'form.start_date'(val) {
      this.weekDaysSelection();
      let date = this.$moment(val);

      if (date.isAfter(this.$moment(this.form.end_date))) { 
        this.form.end_date = this.form.start_date;
      }
    },
    'form.end_date'(val) {
      this.weekDaysSelection();

      let date = this.$moment(val);

      if (date.isBefore(this.$moment(this.form.start_date))) { 
        this.form.start_date = this.form.end_date;
      }
    }
  }
};
